export default __webpack_public_path__ + "static/media/ep_04.a263f353.png";